'use strict';

var App = require('app');
var AppState = require('app_state');
var Consts = require('consts');
var AccountController = require('components/account/account_controller');
var DevicesController = require('components/devices/devices_controller');
var SidebarController = require('components/sidebar/sidebar_controller');
var MenubarController = require('components/menubar/menubar_controller');
var FeedbackDialogView = require('components/common/views/feedback_dialog_view');
var HelpDialogView = require('components/common/views/help_dialog_view');
var i18n = require('utils/i18n');
var Strings = require('utils/strings');
var Theme = require('utils/theme/theme_controller');
var Sidemenu = require('utils/theme/sidemenu');
var ThemeUtils = require('utils/theme/utils');
var Notification = require('utils/notification');
var Utils = require('components/common/utils');

var HomeView = Marionette.LayoutView.extend({
    template: require('components/home/templates/home_layout'),

    regions: {
        menu: '#menu',
        sidebar: '#sidebar',
        breadcrumbs: '#breadcrumbs',
        content: '#content',
    },

    events: {
        'click a.js-logout': 'logout',
        'click a.js-add-device': 'addDevice',
        'click .js-send-feedback': 'showFeedbackDialog',
        'click .js-switch-v2': 'switchFrontend',
        'click #js-mobile-device-search': 'gotoSearchPage',
        'click #js-help': 'startHelpTour',
        'keypress #js-mobile-device-search-term': 'gotoSearchPage',

        'click .js-home-button': function (e) {
            e.preventDefault();
            App.trigger('home:show');
        },
    },

    ui: {
        logoImgX: 'img.menubar-logo-x',
        logoImgS: 'img.menubar-logo-s',
        help: '#js-help',
    },

    logoList: ['logoImgX', 'logoImgS'],

    maxLogoWidth: 490, // trial and error

    gotoSearchPage: function (e) {
        if (e.type === 'keypress' && e.which != 13) {
            // only handle [ENTER] key
            return;
        }

        ThemeUtils.closeSearch();

        e.preventDefault();
        var term = $('#js-mobile-device-search-term').val();
        App.trigger('device:filter', Strings.searchRequest(term));
    },

    getTourRoute: function () {
        // HACK: load controller tour for main page, if current route is ""
        var route = (App.getCurrentRoute() || 'controller').replace('#', '');
        route = route === 'alarm-list' ? 'controller/alarm-list' : route;
        return route;
    },

    updateHelpIcon: function () {
        var self = this;

        var tourInfo = App.request('help:tour', this.getTourRoute(), true);
        $.when(tourInfo).done(function (result) {
            if (!self.isDestroyed) {
                // only show the help-icon, if a tour is available
                result !== undefined ? self.ui.help.show() : self.ui.help.hide();
            }
        });
    },

    startHelpTour: function () {
        if (this.content.currentView) {
            var tourInfo = App.request('help:tour', this.getTourRoute(), false);
            $.when(tourInfo).done(function (result) {
                if (result !== undefined) {
                    App.showModal(new HelpDialogView(result));
                } else {
                    Notification.show('error', i18n.TR('Fehler'), i18n.TR('Hilfe-Tour konnte nicht geladen werden'));
                }
            });
        }
    },

    showFeedbackDialog: function (e) {
        e.preventDefault();
        e.stopPropagation();

        FeedbackDialogView.show();
    },

    switchFrontend: function (e) {
        e.preventDefault();
        e.stopPropagation();

        Utils.showConfirmationDialog({
            title: i18n.TR('Zur neuen Ansicht wechseln'),
            hint:
                i18n.TR('SAM DISTRICT ENERGY wird bald in einer neuen Ansicht zur Verfügung stehen.') +
                '<br />' +
                i18n.TR('Sie können die verbesserte Version bereits jetzt ausprobieren.') +
                '<br />' +
                '<br />' +
                i18n.TR('In Ihrem Profil können Sie die neue Ansicht als Standard festlegen.'),
            action_label: i18n.TR('Wechseln'),
            action_cb: function () {
                window.location = 'v2/';
            },
        });
    },

    logout: function (e) {
        e.preventDefault();
        AccountController.logout();
    },

    addDevice: function (e) {
        e.preventDefault();
        DevicesController.addDevice();
    },

    onShow: function () {
        var self = this;

        this.onResize = function () {
            self.fixLogoSize();
        };

        window.addEventListener('resize', this.onResize);
        window.addEventListener('click', Sidemenu.closeMobileMenu);

        this.fixLogoSize();
    },

    fixLogoSize: function () {
        var self = this;
        if (this.logo === undefined) {
            this.logo = {};

            _.each(this.logoList, function (k) {
                var src = self.ui[k].attr('src');
                // create virtual img and load the source
                var el = document.createElement('img');
                $('body').append(el);
                $(el).css('visibility', 'hidden');
                $(el)
                    .attr('src', src)
                    .load(function () {
                        var newImg = this;
                        setTimeout(function () {
                            self.logo[k] = {
                                width: newImg.width,
                                height: newImg.height,
                            };
                            // remove the virtual img
                            $(el).remove();

                            // trigger the logo width change
                            self.logo[k].lastHeight = 0;
                            self.fixLogoSize();
                        }, 1);
                    });
            });
        }

        // check whether the height is different
        _.each(self.logo, function (v, k) {
            var currentHeight = self.ui[k].prop('height');
            if (currentHeight != v.lastHeight) {
                if (currentHeight > 0) {
                    var w = (currentHeight * v.width) / v.height;
                    if (w > self.maxLogoWidth) {
                        w = self.maxLogoWidth;
                    }
                    self.ui[k].prop('width', w);

                    var h = self.ui[k].prop('height');
                    if (Math.abs(h - currentHeight) == 1) {
                        self.ui[k].prop('height', currentHeight);
                    }
                }
                v.lastHeight = currentHeight;
            }
        });
    },

    onDestroy: function () {
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('click', Sidemenu.closeMobileMenu);
    },

    onBeforeShow: function () {
        SidebarController.resetSidebar();
        MenubarController.resetMenubar();
        var optionalMenuEntries = {};
        if (AppState.hasCompanyPermission(Consts.PermissionsCompany.AddDevices)) {
            // show menu entry for device registration
            optionalMenuEntries.addDevice = true;
        }

        if (!AppState.user.isDemoUser()) {
            // show menu entry for profile settings
            optionalMenuEntries.settings = true;
        }
        App.trigger('menubar:change', optionalMenuEntries);
    },

    onAttach: function () {
        Theme.InitializeSidemenuToggle();
        this.updateHelpIcon();
    },

    serializeData: function () {
        var data = Marionette.LayoutView.prototype.serializeData.apply(this, arguments);

        data.showOSLicenceLink = TC_DEBUG;

        return data;
    },
});

module.exports = HomeView;
